module.exports = __webpack_public_path__ + "static/media/features-split-image-01.9b3b598b.png";